import { gql } from '@apollo/client'

export const GET_COUNTRY_LIST = gql`
  query {
    getCountryList {
      code
      name
    }
  }
`
